import React from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import { List, ListItem } from '@material-ui/core';
import UseJoyride from './UseJoyride';
import DMstep1 from './assets/DMstep1.png';
import DMstep2 from './assets/DMstep2.png';
import DMstep3 from './assets/DMstep3.png';
import DMstep4 from './assets/DMstep4.png';

const DealMapperJoyride = () => {
  const DMStepOne = () => {
    return (
      <div>
        <img src={DMstep1} alt="menu screenshot" width="200px" />
        <p>
          Find a transaction by typing the address or deal number into the
          search menu. Double click the deal to add to the deal map workspace.
        </p>
      </div>
    );
  };
  const DMStepTwo = () => {
    return (
      <div>
        <img src={DMstep2} alt="menu screenshot" width="100%" />
        <p>
          Choose “fill deals” and the system to automatically match payments
          with outstanding balances.
        </p>
      </div>
    );
  };
  const DMStepThree = () => {
    return (
      <div>
        <img src={DMstep3} alt="menu screenshot" width="100%" />
        <p>
          If you have a match, congratulations! Click Save Changes on the
          toolbar, or click the matching amount highlighted green to edit the
          transaction.
        </p>
      </div>
    );
  };
  const DMStepFour = () => {
    return (
      <div>
        <img src={DMstep4} alt="menu screenshot" width="100%" />
        <p>From here you can edit the amount.</p>
      </div>
    );
  };
  return (
    <Observer
      render={() => {
        const steps = [
          {
            target: '.dmStep1',
            content: <DMStepOne />,
            disableBeacon: true,
          },
          {
            target: '.dmStep2',
            content: <DMStepTwo />,
            styles: { tooltip: { width: '500px' } },
          },
          {
            target: '.dmStep3',
            content: <DMStepThree />,
            styles: { tooltip: { width: '800px' } },
            offset: '40',
            placement: 'center',
          },
          {
            target: '.dmStep4',
            content: <DMStepFour />,
            styles: { tooltip: { width: '800px' } },
            offset: '40',
            placement: 'center',
          },
        ];
        return (
          <UseJoyride passedSteps={steps} customProps={{ continuous: true }} />
        );
      }}
    />
  );
};

export default DealMapperJoyride;
